import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './Navbar.css';
import LogoBlank from '../Images/brandmark-design-logo-transparent.png';

const Navbar = ({ openCalendlyModal }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBookNow = () => {
    openCalendlyModal();
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <ScrollLink
          to="hero"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="navbar-logo"
        >
          <img src={LogoBlank} alt="Logo" className="logo-image" />
          <span className="logo-text">ByteSand</span>
        </ScrollLink>

        {/* Desktop Menu */}
        <div className="navbar-links">
          <button className="navbar-cta desktop-cta" onClick={handleBookNow}>
            Book Now
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle mobile menu"
        >
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isOpen ? 'mobile-menu-open' : ''}`}>
          <button className="mobile-nav-link" onClick={handleBookNow}>
            Book Now
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;